import { render, staticRenderFns } from "./ViewCoupon.vue?vue&type=template&id=515edde8&scoped=true&"
import script from "./ViewCoupon.vue?vue&type=script&lang=js&"
export * from "./ViewCoupon.vue?vue&type=script&lang=js&"
import style0 from "./ViewCoupon.vue?vue&type=style&index=0&id=515edde8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../fodchef/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "515edde8",
  null
  
)

export default component.exports